import {Component, EventEmitter, Input, Output} from "@angular/core";
import {LogicGroupType} from "../../models/jsonlogic/logic-group-type";

@Component({
  selector: "and-or",
  templateUrl: "./and_or.component.html",
})
export class AndOrComponent {

  public items: string[] = ["AND", "OR"];
  @Input() public selectedItem: LogicGroupType;
  @Input() public readonly: boolean = false;
  @Output() public valueChanged = new EventEmitter();

  public changeValue(choice: string): void {
    if (choice === "AND") {
      this.selectedItem = LogicGroupType.AND;
    } else {
      this.selectedItem = LogicGroupType.OR;
    }
    this.valueChanged.emit(choice);
  }
}
